export default {"src":"/_next/static/media/heart-blue.da64fb8f.svg","height":17,"width":18,"blurWidth":0,"blurHeight":0};